export default "__VITE_ASSET__B6$iWSko__"